import { splitSpan, createSeedBlob, createBlob } from './utils'

export const top = () => {
  const breakPoint = window.matchMedia('(min-width: 760px)')
  const topCatchphrase = document.querySelector('.top-catchphrase')
  topCatchphrase.innerHTML = splitSpan(topCatchphrase.textContent)

  if (!sessionStorage.getItem('firstAccess')) {
    sessionStorage.setItem('firstAccess', 0)
    document.body.style.position = 'fixed'
    document.querySelector('.loading').style.display = 'flex'
    window.addEventListener('load', () => {
      gsap
        .timeline({
          delay: 2,
        })
        .to(
          '.loading-claypipe',
          {
            duration: 0,
            ease: 'expo.out',
            y: '0',
          },
          0,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.1,
            ease: 'expo.out',
            y: '50px',
          },
          0.01,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.1,
            ease: 'bounce.out',
            y: '0',
          },
          0.05,
        )
        .to(
          '.loading-balloonItem0',
          {
            duration: 0.1,
            ease: 'expo.out',
            opacity: 0.5,
            y: window.innerHeight < 900 ? '0' : '55%',
          },
          0.06,
        )
        .to(
          '.loading-balloonItem0',
          {
            duration: 30,
            ease: 'expo.out',
            y: '-200%',
          },
          0.1,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.1,
            ease: 'bounce.out',
            x: '-70%',
          },
          0.2,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.1,
            ease: 'expo.out',
            y: '50px',
          },
          0.21,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.1,
            ease: 'bounce.out',
            y: '0px',
          },
          0.25,
        )
        .to(
          '.loading-balloonItem4_1',
          {
            duration: 0.1,
            ease: 'expo.out',
            opacity: 0.5,
            y: window.innerHeight < 900 ? '0' : '55%',
          },
          0.26,
        )
        .to(
          '.loading-balloonItem4_1',
          {
            duration: 30,
            ease: 'expo.out',
            y: '-200%',
          },
          0.3,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.1,
            ease: 'bounce.out',
            x: '74%',
          },
          0.4,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.1,
            ease: 'expo.out',
            y: '50px',
          },
          0.6,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.1,
            ease: 'bounce.out',
            y: '0px',
          },
          0.62,
        )
        .to(
          '.loading-balloonItem4_2',
          {
            duration: 0.1,
            ease: 'expo.out',
            opacity: 0.5,
            y: window.innerHeight < 900 ? '0' : '55%',
          },
          0.63,
        )
        .to(
          '.loading-balloonItem4_2',
          {
            duration: 30,
            ease: 'expo.out',
            y: '-200%',
          },
          0.65,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.05,
            ease: 'expo.out',
            y: '100%',
          },
          0.7,
        )
        .to(
          '.loading-claypipe',
          {
            duration: 0.05,
            ease: 'expo.out',
            x: 0,
            y: '0',
          },
          1.5,
        )
        .to(
          '.loading-greenpipe',
          {
            duration: 0.5,
            ease: 'expo.out',
            y: '100%',
          },
          1.5,
        )
        .to(
          '.loading',
          {
            onStart: () => {
              document.querySelector('.joinClan').style.opacity = 1
              document.querySelector('.topHeader').style.opacity = 1
              document.querySelector('.top-wrapper').style.opacity = 1

              const loadingEndEvent = new Event('animeend')
              window.dispatchEvent(loadingEndEvent)
            },
            duration: 0.7,
            ease: 'bounce.out',
            height: 0,
            onComplete: () => {
              setTimeout(() => {
                document.querySelector('.loading').remove()
                document.body.style.position = 'relative'
              }, 500)
            },
          },
          1.5,
        )
        .to(
          '.top-catchphrase span',
          {
            duration: 0.1,
            ease: 'power1.out',
            display: 'inline-block',
            stagger: 0.1,
            onComplete: () => {
              setTimeout(() => {
                topCatchphrase.classList.add('isEnd')
              }, 3000)
            },
          },
          1.56,
        )
    })
  } else {
    window.addEventListener('load', () => {
      document.querySelector('.joinClan').style.opacity = 1
      document.querySelector('.topHeader').style.opacity = 1
      document.querySelector('.top-wrapper').style.opacity = 1
      const privacyInfo = document.querySelector('.js-privacyInfo')
      if (privacyInfo) {
        document.querySelector('.js-privacyInfo').classList.add('is-active')
      }
      gsap.to('.top-catchphrase span', {
        delay: 1.3,
        duration: 0.1,
        ease: 'power1.out',
        display: 'inline-block',
        stagger: 0.1,
        onComplete: () => {
          setTimeout(() => {
            topCatchphrase.classList.add('isEnd')
          }, 3000)
        },
      })
    })
  }

  const topSecs = document.querySelectorAll('.top-sec')
  const scrollEvent = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target)
        if (entry.target.classList.contains('whats')) {
          gsap.to('.whatsPaint-line', {
            duration: 0.4,
            ease: 'expo.inOut',
            strokeDashoffset: 0,
            stagger: {
              each: 0.04,
              from: 'random',
            },
          })
        }
        if (entry.target.classList.contains('quest404')) {
          gsap
            .timeline({})
            .to(
              '.claypipe2',
              {
                duration: 0.5,
                ease: 'bounce.out',
                x: 0,
              },
              0,
            )
            .to(
              '.quest404-thumbnail',
              {
                duration: 1,
                ease: 'expo.out',
                x: 0,
                y: 0,
                rotate: 0,
                stagger: 0.2,
              },
              0.25,
            )
            .to(
              '.quest404-illustration',
              {
                duration: 1,
                ease: 'expo.out',
                x: 0,
                y: 0,
                rotate: 0,
                stagger: 0.2,
              },
              0.35,
            )
          gsap
            .timeline({
              delay: 0.3,
              duration: 0.5,
              repeat: -1,
            })
            .to('.claypipe2', {
              ease: 'bounce.out',
              x: '-100%',
            })
            .to('.claypipe2', {
              ease: 'bounce.out',
              x: '0%',
            })
        }
      }
    })
  }
  const options = {
    root: null,
    rootMargin: '-50% 0px',
    threshold: 0,
  }
  const observer = new IntersectionObserver(scrollEvent, options)
  topSecs.forEach((topSec) => {
    observer.observe(topSec)
  })

  const blob = () => {
    // let seed = 12345; // 任意のシード値を設定

    document.querySelectorAll('.puddle-path').forEach((puddlePath) => {
      createBlob({
        element: puddlePath,
        numPoints: 28,
        centerX: window.innerWidth / 2,
        centerY: window.innerHeight / 2,
        minRadius: 400,
        maxRadius: 500,
        minDuration: 1,
        maxDuration: 10,
      })
    })

    const changeBreakPointCreateBlob = (e) => {
      if (!e.matches) {
        // mobile
        createBlob({
          element: document.querySelector('.blob-path'),
          numPoints: 15,
          centerX: 0,
          centerY: 0,
          minRadius: 50,
          maxRadius: 100,
          minDuration: 5,
          maxDuration: 10,
        })
      } else {
        // pc
        createBlob({
          element: document.querySelector('.blob-path'),
          numPoints: 15,
          centerX: 0,
          centerY: 0,
          minRadius: 100,
          maxRadius: 230,
          minDuration: 1,
          maxDuration: 9,
        })
      }
    }

    changeBreakPointCreateBlob(breakPoint)
    breakPoint.addListener(changeBreakPointCreateBlob)
  }

  const whatsPaint = () => {
    const initStroke = (element) => {
      const length = element.getTotalLength()
      element.style.strokeDasharray = length
      element.style.strokeDashoffset = length
    }
    document.querySelectorAll('.whatsPaint-line').forEach((whatsPaintLine) => {
      initStroke(whatsPaintLine)
    })
  }

  const setViewBox = () => {
    document
      .querySelector('.puddle-svg')
      .setAttribute('viewBox', `0 0 ${window.innerWidth} ${window.innerHeight}`)
    document
      .querySelector('.blob-svg')
      .setAttribute('viewBox', `0 0 ${window.innerWidth} ${window.innerHeight}`)
    document
      .querySelector('.whatsPaint-svg')
      .setAttribute('viewBox', `0 0 ${window.innerWidth} 1800`)
  }

  blob()
  setViewBox()
  whatsPaint()

  const swiperThankfulEvent = new Swiper('.swiper-thankfulEvent', {
    grabCursor: true,
    slidesPerView: 'auto',
    centeredSlides: false,
    spaceBetween: 30,
    // modules: [Navigation],
    navigation: {
      nextEl: '.swiper-button-next-event',
      prevEl: '.swiper-button-prev-event',
    },
  })

  const swiperClanPost = new Swiper('.swiper-clanPost', {
    grabCursor: true,
    slidesPerView: '2',
    centeredSlides: false,
    spaceBetween: 40,
  })

  let currentWidth = window.innerWidth
  const breakpoint = 760
  window.addEventListener('resize', () => {
    const newWidth = window.innerWidth

    document
      .querySelector('.puddle-svg')
      .setAttribute('viewBox', `0 0 ${window.innerWidth} ${window.innerHeight}`)
    document
      .querySelector('.blob-svg')
      .setAttribute('viewBox', `0 0 ${window.innerWidth} ${window.innerHeight}`)
    document
      .querySelector('.whatsPaint-svg')
      .setAttribute('viewBox', `0 0 ${window.innerWidth} 1800`)

    if (
      (currentWidth < breakpoint && newWidth >= breakpoint) ||
      (currentWidth >= breakpoint && newWidth < breakpoint)
    ) {
      location.reload()
    }
    currentWidth = newWidth
  })
}
